import Swiper from "swiper";
import { find } from "../utils/dom";

const PageAconteceu = () =>{

	const page = find(`[js-page='aconteceu']`);
	if(!page) return;
 
	const swiperCategoria = new Swiper(".swiper-categorias",{
		slidesPerView: 'auto',
		spaceBetween: 8,
	})
}

export default PageAconteceu;